import s from '../../styles/shared/page.module.css';
import table from '../../styles/shared/table.module.css';

export default function DeliveryStatsCell({ sent, delivered, failed, hasDetails, detailsLabel, onOpenDetails }) {
  return (
    <div className={`${table.cellInsider} ${table.cellWrap}`} style={{ paddingInline: '8px' }}>
      <div className={s.channelCell}>
        <div className={s.channelStats}>
          <span className={s.channelSent}>{sent} sent</span>
          {sent > 0 && delivered > 0 && <span className={s.channelDelivered}>{delivered} delivered</span>}
          {sent > 0 && failed > 0 && <span className={s.channelFailedText}>{failed} failed</span>}
        </div>
        {hasDetails && (
          <button
            type="button"
            className={`${s.chipButton} ${s.chipButtonIcon}`}
            onClick={onOpenDetails}
            aria-label={detailsLabel}
            title={detailsLabel}
          >
            <i className="pi pi-info-circle" />
          </button>
        )}
      </div>
    </div>
  );
}
